<template>
  <div class="activityEdit">
    <van-nav-bar
      title="活动修改"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
    />
    <div class="content margin_top_content">
      <p class="head_title">{{ agentName }}</p>
      <van-cell @click="selectActivity" :title="activity.activName" :is-link="list.length !== 1" />
    </div>
    <p class="title margin_top_title">押金退还配置</p>
    <div class="content">
      <van-field
        v-model="activity.mercCash"
        type="number"
        input-align="right"
        label="机具押金(元)"
        disabled
        placeholder="请输入机具押金"
      />
      <van-field
        :value="orgBackcash"
        type="number"
        input-align="right"
        clickable
        @click="selectOrgBackCash"
        readonly
        label="返机构金额(元)"
        placeholder="请输入返机构金额"
        right-icon="arrow"
      />
      <van-field
        :value="mercBackcash"
        type="number"
        input-align="right"
        error-message-align="right"
        disabled
        label="返商户金额(元)"
        :error-message="errorMessage"
        placeholder="请输入返商户金额"
      />
    </div>
    <p class="title">活动返现配置</p>
    <div class="content">
      <van-field
        v-model="activity.backCash"
        type="number"
        input-align="right"
        label="返现给我(元)"
        disabled
        placeholder="请输入金额"
      />
      <van-field
        :value="backCash"
        input-align="right"
        error-message-align="right"
        :disabled="!activity.backCash"
        @input="limitInputBackCash"
        label="我返下级(元)"
        placeholder="请输入金额"
        :error-message="notZero"
      />
    </div>
    <!-- <div class="explain">
      <p>1、您的上级给您配置了返现后，您才能给您下级配置返现；</p>
    </div> -->
    <button class="btn confirm" @click="confirmEdit">确认</button>
    <button class="btn cancel" @click="cancelEdit">取消</button>
    <van-popup v-model="show" position="bottom" class="bottomPopup">
      <van-cell
        class="cellText"
        v-for="(item, index) in list"
        :key="item.activNo"
        @click="cellClick(item)"
      >
        <p>{{ item.activName }}</p>
      </van-cell>
    </van-popup>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, Cell, CellGroup, Popup, Dialog, Picker } from 'vant';
export default {
  name: 'activityEdit',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Picker.name]: Picker
  },
  data() {
    return {
      columns: [],
      showPicker: false,
      errorMessage: '',
      notZero: '',
      show: false,
      list: [],
      backCash: 0,
      orgBackcash: 0,
      activity: {
        mercCash: 0,
        backCash: 0,
        mercBackcash: 0,
        activType: '',
        activName: '请选择活动',
        activNo: ''
      },
      agentName: '',
      agentId: '',
      agentNo: '',
      mercBackcash: 0
    };
  },
  created() {
    if (this.$route.query.agentId) {
      this.agentId = this.$route.query.agentId;
      this.agentNo = this.$route.query.agentNo;
      this.agentName = this.$route.query.agentName;
      this.getActivityList();
    }
  },
  methods: {
    selectOrgBackCash() {
      if (this.activity.activName === '请选择活动') {
        this.$toast('请先选择活动');
        return false;
      }
      this.getOrgBackCash();
    },
    getOrgBackCash() {
      this.columns = [];
      this.$http.post({
        url: '/csps-api/crmCashbackMode/crmCashbackModeListByMoney',
        data: {
          payCash: this.activity.mercCash
        }
      }).then(res => {
        console.log(res);
        if (!res.data.result.length) {
          this.$dialog.alert({
            title: '提示',
            confirmButtonText: '知道啦',
            message: `<p>暂未获取到配置金额</p>`
          }).then(() => {
            if (/android/i.test(navigator.userAgent)) {
              window.android.finishActivity();
            };

            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
              window.webkit.messageHandlers.goBack.postMessage(null);
            };
          });
        } else {
          res.data.result.forEach(item => {
            this.columns.push(item.orgCashBack);
          });
          this.showPicker = true;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onConfirm(value) {
      this.orgBackcash = value;
      this.mercBackcash = this.activity.mercCash - value;
      this.showPicker = false;
    },
    limitInputMercBackcash(value) {
      if (value > this.activity.mercCash) {
        this.errorMessage = `金额不能大于${this.activity.mercCash}`;
      } else if(!/^[0-9]+(\.[0-9]{1,2})?$/.test(value)) {
        this.errorMessage = '只能输入两位小数';
      } else {
        this.errorMessage = '';
        this.mercBackcash = value;
      }
    },
    limitInputBackCash(value) {
      if (value === '') {
        this.notZero = '';
        this.backCash = value;
        return false;
      }
      if (value > this.activity.backCash) {
        this.notZero = `金额不能大于${this.activity.backCash}`
      } else if(!/^[0-9]+(\.[0-9]{1,2})?$/.test(value)) {
        this.notZero = '精确到两位小数';
      } else {
        this.notZero = '';
        this.backCash = value;
      }
    },
    confirmEdit() {
      if (this.activity.activName === '请选择活动') {
        this.$toast('请先选择活动');
        return false;
      }
      if (this.backCash > this.activity.backCash) {
        this.$toast(`您配置的金额不能大于${this.activity.backCash}`);
        return false;
      }
      if (this.backCash === '' || this.activity.backCash === 0 || this.backCash == 0) {
        this.notZero = '我返下级金额要大于0';
        return false;
      }
      if (this.errorMessage === '' && this.notZero === '') {
        this.updateActivity();
      }
    },
    cancelEdit() {
      if (/android/i.test(navigator.userAgent)) {
        window.android.finishActivity();
      };

      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.webkit.messageHandlers.goBack.postMessage(null);
      };
    },
    getActivityList() {
      this.$http.post({
        url: '/csps-api/activitychanges/updateactivity',
        data: {
          agentId: this.agentId
        }
      }).then(res => {
        console.log(res);
        this.list = res.data.result;
        if (!this.list.length) {
          this.$dialog.alert({
            title: '配置须知',
            confirmButtonText: '知道啦',
            message: `<p style="text-align: left">请联系您的业务对接人申请修改活动配置权限</p>`
          }).then(() => {
            if (/android/i.test(navigator.userAgent)) {
              window.android.finishActivity();
            };

            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
              window.webkit.messageHandlers.goBack.postMessage(null);
            };
          });
        }
        if (this.list.length === 1) {
          this.activity = Object.assign({}, this.list[0]);
          this.orgBackcash = this.activity.orgBackcash === undefined ? this.activity.mercCash : this.activity.orgBackcash;
          this.mercBackcash = this.activity.mercBackcash || 0;
          this.backCash = this.activity.bankCashXj || '';
          this.getOrgBackCash();
        }
      }).catch(error => {
        console.log(error);
      });
    },
    updateActivity() {
      const data = {
        activType: this.activity.activType,
        activName: this.activity.activName,
        activNo: this.activity.activNo,
        backCash: this.backCash,
        orgBackcash: this.orgBackcash,
        mercBackcash: this.mercBackcash,
        agentNo: this.agentNo,
        agentName: this.agentName,
        agentId: this.agentId
      };
      console.log(data);
      this.$http.post({
        url: '/csps-api/activitychanges/updateActivityByActivNo',
        data
      }).then(res => {
        console.log(res);
        this.$dialog.alert({
          title: '提示',
          message: '修改成功'
        }).then(() => {
          if (/android/i.test(navigator.userAgent)) {
            window.android.finishActivity();
          };

          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            window.webkit.messageHandlers.goBack.postMessage(null);
          };
        });
      }).catch(error => {
        console.log(error);
      });
    },
    onClickLeft() {
      if (/android/i.test(navigator.userAgent)) {
        window.android.finishActivity();
      };

      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        window.webkit.messageHandlers.goBack.postMessage(null);
      };
    },
    selectActivity() {
      if (this.list.length !== 1) {
        this.show = true;
      }
    },
    cellClick(item) {
      console.log(item);
      if (item.activType === '0') {
        this.$toast('该功能暂未开放，敬请期待');
        return false;
      }
      this.activity = Object.assign({}, item);
      this.orgBackcash = this.activity.orgBackcash === undefined ? this.activity.mercCash : this.activity.orgBackcash;
      this.mercBackcash = this.activity.mercBackcash || 0;
      this.backCash = this.activity.bankCashXj || '';
      this.show = false;
    }
  }
};
</script>

<style scoped>
.head_title{
  font-size: 16px;
  color: #464646;
  padding: 15px 0;
  border-bottom: 1px solid #DCD9D9;
}
.margin_top_title{
  margin-top: 10px;
}
.margin_top_content{
  margin-top: 46px;
}
.title{
  font-size: 14px;
  color: #464646;
  background-color: #D8DFEC;
  padding: 12px 0 12px 16px;
  font-weight: 600;
}
.content{
  padding: 0 15px;
}
.explain{
  font-size: 12px;
  color: #9B9B9B;
  padding: 15px;
  line-height: 20px;
}
.btn{
  width: 90%;
  margin-left: 5%;
  font-size: 18px;
  border: none;
  outline: none;
  border-radius: 26px;
  padding: 12px 0;
  margin-top: 20px;
  text-indent: 10px;
  letter-spacing: 10px;
}
.confirm{
  color: #ffffff;
  background-color: #1D7BF9;
}
.cancel{
  color: #9B9B9B;
  background-color: #ffffff;
  border: 1px solid #9B9B9B;
  margin-bottom: 20px;
}
.bottomPopup{
  height: 50%;
}
.cellText{
  padding-left: 10px;
}
</style>